<template>
    <b-tab no-body :title="$t('message.compteRenduOperatoire')" :active="pathHas('compteRenduOperatoire') ">
        <div id="compteRenduOperatoire">
            <h3 class="text-center"> {{ $t('message.compteRenduOperatoire') }}</h3>
            <b-link class="ml-4" variant="primary" @click="toCompteRendu" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                <i class="fas fa-plus-circle edit-icon"></i>{{ $t('message.compteRenduOperatoire') }}
            </b-link>
            <b-card-body>
            <!-- version desktop -->
            <vue-good-table v-if="notEmpty(comptesRenduOpRows) && !mobileView " :columns="comptesRenduOpColumns" :rows="comptesRenduOpRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onComptesRenduOpRowClick" />        
             
             <!-- version mobile -->
             <div id="table-demo" v-if="mobileView"> <!-- && !mobileView -->
                        <div class="ltemp--content--box border border-1 py-2 my-2 rounded bg-white" v-for="(row, x) in comptesRenduOpRows" :key="x"  @click="onComptesRenduOpRowClickMobile(row.slug)">
                            <div class="trajet__info bg-white mt-2" > <!-- v-for="(item, index) in ligne_temps" :key="index" -->
                                <div class="trajet__info--text h-100 d-flex align-items-center justify-content-between fs-6">
                                    <span class="d-flex align-items-center text-gray px-3">
                                        <i class="fa fa-calendar" aria-hidden="true"></i>
                                        <span class="px-1">{{row.date}}</span>
                                    </span>
                                    <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                    <span class="text-default text-gray px-1">{{row.etablissement}}</span>
                                    <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                    <span class="text-default d-none d-md-block">{{row.typeIntervention}}</span>
                                    <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                    <span class="text-default d-none d-md-block"></span>
                                    <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                    <span class="px-3">
                                        <b-button class="border-0 p-0 d-flex align-items-center shadow-none bg-transparent text-primary" @click="onComptesRenduOpRowClickMobile(row.slug) "><!-- :to="{ name: 'consultation-general' , params: { file: this.$route.params.file } }" -->
                                            <span class="d-none d-md-block">Voir</span>
                                            <i class="fa fa-eye" aria-hidden="true"></i>
                                        </b-button> 
                                    </span>
                                </div>
                            </div>
                        </div>
             </div>
            
            </b-card-body>
        </div>
    </b-tab>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import moment from "moment";
export default {
    name: "CompteRendu",
    computed: {
         ...mapGetters(["file"]),

        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
        comptesRenduOpRows: function () {
            let self = this;
            let cArray = [];

            _.forEach(self.mMedicalFile.comptes_rendu_operatoire, function (compte) {
                let c = {};
                let etablissement = ''
                if (!_.isNull(compte.etablissement_id)) {
                    if (compte.hasOwnProperty('etablissement')) {
                        if (!_.isNull(compte.etablissement)) {
                            etablissement = compte.etablissement.name;
                        } else {
                            etablissement = "";
                        }
                    }
                }
                c.etablissement = etablissement;
                c.type = compte.type_intervention;
                c.date = moment(compte.date_intervention).format('YYYY-MM-DD HH:mm');
                c.slug = compte.slug;
                cArray.push(c);
            });

            return cArray;
        },
    },
    props: ['hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasPraticienRole', 'file_id'],
    data() {
        return {
            mobileView:true,
            comptesRenduOpColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                // {
                //   label: this.$i18n.tc('message.practitioners',1),
                //   field: 'praticien',
                // },
                {
                    label: this.$i18n.t('message.typeIntervention'),
                    field: 'type',
                },
                {
                    label: this.$i18n.t('message.dateIntervention'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd HH:mm',
                    dateOutputFormat: 'dd/MM/yyyy HH:mm',
                },
            ],
            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
            
        }
    },
    validations() {
        return {
            form: {
                responsable:{},
            }
        }
	},
    methods: {
        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },
        toCompteRendu() {
            this.$router.push({
                name: 'add-compte-rendu',
                params: {
                    file: this.file_id
                }
            })
        },
        onComptesRenduOpRowClick(params) {
            this.$router.push({
                name: 'compte-rendu',
                params: {
                    compteRendu: params.row.slug
                }
            });
        },
         onComptesRenduOpRowClickMobile(params) {
            this.$router.push({
                name: 'compte-rendu',
                params: {
                    compteRendu: params
                }
            });
        },

        pathHas(element) {
        let result = (this.$route.fullPath).includes(element);
            if (result) {
                if ($('#' + element).length) {
                    document.getElementById(element).scrollIntoView(top);
                }
            }

            return result;
        },
        notEmpty(item) {
            return item.length > 0;
        },
    },
    created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
    },
    mounted() {
        
    }
}
</script>
<style lang="">
    
</style>